import React from "react";
import { format } from 'date-fns';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import {useSxStyles as classes} from "../styles/sxStyles";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
// import Button from '@mui/material/Button';

const CallLog = (props) => {
    const entries = props.entries;
    const setEntries = props.setEntries;

    const handleClose = () => {
        setEntries(null);
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport
                    csvOptions={{
                        fileName: `callLog-${format(new Date(), 'yyyyMMdd_HHmmss')}`
                    }}
                />
                <Button color='primary' size='small' startIcon={<RefreshIcon/>} onClick={handleClose}>Close</Button>
            </GridToolbarContainer>
        );
    }

    const columns = [
        {field: 'id', headerName: 'ID', width: 0, disableExport: true},
        {field: 'callTime', headerName: 'Call Time', flex: 3},
        {field: 'callerFirstName', headerName: 'First Name', flex: 3},
        {field: 'callerLastName', headerName: 'Last Name', flex: 3},
        {field: 'outcome', headerName: 'Outcome', flex: 3},
        {field: 'outcomeReason', headerName: 'Reason', flex: 4},
        {field: 'comments', headerName: 'Comment', flex: 4},
        {
            field: 'auth',
            headerName: 'Trans. ID',
            flex: 3,
            valueGetter: (params) => {
                return params?.transId || '';
            }
        },
        {field: 'agentId', headerName: 'Agent', flex: 3},
    ];

    return (
        <>
            <Typography variant="h5" color='primary' sx={{...classes.controlPanel, marginTop:'0'}}>Call Log Report</Typography>
            <Box sx={{height: 'auto', overflow: 'auto', width: 'auto', marginBottom: '.5rem'}}>
                <DataGrid
                    columns={columns}
                    rows={entries}
                    disableRowSelectionOnClick
                    suppressFieldDotNotation={false}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            }
                        },
                        pagination: {
                            paginationModel: {
                                pageSize: 25,
                            },
                        },
                    }}
                    pageSizeOptions={[25, 50, 100]}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                />
            </Box>
        </>
    );
}

export default CallLog;
